import { getApiBaseUrl } from '../../utils/environment.mjs';
// ApiService.js
// SECURITY: This service uses httpOnly cookies for authentication (withCredentials: true)
// Do NOT store tokens in localStorage - they are vulnerable to XSS attacks
import axios from 'axios';

const API_URL = getApiBaseUrl();

const ApiService = axios.create({
  baseURL: API_URL,
  withCredentials: true, // SECURITY: Use httpOnly cookies instead of localStorage tokens
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - cookies are sent automatically with withCredentials: true
ApiService.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

// Response interceptor
ApiService.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle common errors (401, 403, 500, etc.)
    if (error.response) {
      const { status } = error.response;

      if (status === 401) {
        // Unauthorized - redirect to login
        window.location.href = '/login';
      }

      // SECURITY: Don't log detailed error messages to console in production
      // Error details should be handled by the calling code
    }

    return Promise.reject(error);
  }
);

export default ApiService;


